import React from 'react';
import './styles.css';
import BasicInput from '../../../BasicInput';

const CheckboxSearch = ({ value, onChange }) => (
  <div className="checkbox__search">
    <BasicInput
      name="Search"
      inputType="text"
      content={value}
      placeholder="Start typing here..."
      controlFunc={onChange}
      isValid={true}
      inputStyles={{
        height: '40px',
        padding: '4px 15px 4px 18px',
        border: 'none',
        borderBottom: '1px solid #dddddd',
        outline: 'none',
      }}
    />
  </div>
);

export default CheckboxSearch;
